import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Search, X } from "lucide-react";
import { API, authHeaders, d } from "@/components/admin/ui";

const GROUPS = [["clients", "Clients", (r) => r.nom || r.email, (r) => r.email], ["reservations", "Réservations", (r) => `${r.reference} · ${r.nom}`, (r) => r.event_titre], ["sessions", "Sessions", (r) => r.titre, (r) => d(r.date)], ["produits", "Produits", (r) => r.nom, (r) => `${r.numero} · ${r.statut_stock || ""}`], ["commandes", "Commandes", (r) => r.numero, (r) => r.statut]];

export const GlobalSearch = ({ onOpen }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const timer = useRef();
  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setRes(null); return undefined; }
    timer.current = setTimeout(() => axios.get(`${API}/admin/hub/recherche`, { ...authHeaders(), params: { q } }).then((r) => setRes(r.data)).catch(() => setRes(null)), 250);
    return () => clearTimeout(timer.current);
  }, [q]);
  const pick = (group, row) => { onOpen(group, row); setQ(""); setRes(null); };
  const count = res ? GROUPS.reduce((n, [k]) => n + res[k].length, 0) : 0;
  return (
    <div className="relative w-full sm:w-80" data-testid="admin-global-search">
      <Search className="w-4 h-4 text-fumee absolute left-3 top-2.5" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher client, réservation, session…" className="w-full pl-9 pr-8 py-2 bg-white/70 border border-wood/25 rounded-full text-sm focus:outline-none focus:border-terra" data-testid="admin-global-search-input" />
      {q && <button type="button" onClick={() => setQ("")} className="absolute right-3 top-2.5 text-fumee" aria-label="Effacer"><X className="w-4 h-4" /></button>}
      {res && <div className="absolute z-50 mt-2 w-full sm:w-[28rem] right-0 bg-card border border-sand-dark rounded-xl shadow-xl max-h-[70vh] overflow-y-auto p-2" data-testid="admin-global-search-results">
        {count === 0 && <p className="p-3 text-sm text-fumee">Aucun résultat.</p>}
        {GROUPS.map(([key, label, title, sub]) => res[key].length > 0 && <div key={key} className="py-1">
          <p className="px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-fumee">{label}</p>
          {res[key].map((row) => <button type="button" key={row.id} onClick={() => pick(key, row)} className="w-full text-left px-3 py-2 rounded-lg hover:bg-sand" data-testid={`admin-search-${key}-${row.id.slice(0, 8)}`}><span className="block text-sm text-bark truncate">{title(row)}</span><span className="block text-xs text-fumee truncate">{sub(row)}</span></button>)}
        </div>)}
      </div>}
    </div>
  );
};
